import type { ComponentPropsWithRef, ReactNode } from 'react'
import { useId } from 'react'

export interface SelectInputProps extends Omit<
    ComponentPropsWithRef<'select'>,
    'value' | 'defaultValue'
> {
    defaultValue?: string | number | readonly string[] | null
    useBookingFormThemeCssVariables?: boolean
    children?: ReactNode
}

export function SelectInput({
    defaultValue,
    id,
    name,
    disabled = false,
    useBookingFormThemeCssVariables = false,
    className = '',
    children,
    ...selectProps
}: SelectInputProps) {
    const generatedId = useId()
    const selectId = id ?? (name ? name : generatedId)

    const focusClassName = useBookingFormThemeCssVariables
        ? 'focus:ring-booking-form-theme-main-background-color focus:border-booking-form-theme-main-background-color'
        : 'focus:ring-primary focus:border-primary'

    return (
        <select
            {...selectProps}
            id={selectId}
            name={name}
            disabled={disabled}
            defaultValue={defaultValue ?? undefined}
            className={`w-full shadow-xs bg-white border border-stone-200 rounded-lg2 disabled:bg-stone-100 disabled:cursor-not-allowed disabled:text-gray-500 disabled:select-none focus:outline-none focus:ring-1 ${focusClassName} ${className}`.trim()}
        >
            {children}
        </select>
    )
}
